import { defineMessages } from 'react-intl';

const messages = defineMessages({
  notesSectionTitle: {
    defaultMessage: 'Notes',
    description: 'Order details shipment notes section header',
    id: 'KGEwtk',
  },
  sectionAriaLabel: {
    defaultMessage: 'Notes expander section',
    description: 'Aria label for the expandable notes section',
    id: 'QAla6X',
  },
  demoTooltipText: {
    description: 'Tooltip text for the demo green star on the Notes section',
    defaultMessage: 'Notes can import with an order (if your store sends them) or be added manually.',
    id: 'JI/cD1',
  },
  demoTooltipAltText: {
    description: 'Alt text for the demo green star on the Notes section',
    defaultMessage: 'Green star tooltip explaining Notes',
    id: 'Aa6BH+',
  },
});

export default messages;
